const CERTIFICATION_CREDITS: Record<string, number> = {
	"certified-personal-trainer": 50,
	"human-movement-specialist": 60,
	"integrated-manual-therapist-mt": 80,
	"strength-and-performance-coach": 100,
};

const normalizeCertificationSlug = (slug: string): string =>
	slug.replace(/-legacy(-\d+)?$/, "").replace(/-original$/, "");

/**
 * Credits shown on landing-page module breakdowns.
 * CPT legacy / original variants map to the current BI-CPT (50).
 */
export const getLandingPageCertificationCredits = (slug: string): number => {
	const normalized = normalizeCertificationSlug(slug);
	return CERTIFICATION_CREDITS[normalized] ?? 0;
};

/**
 * Recommended course plan href for the modules section.
 * CPT legacy linked certs must deep-link the current BI-CPT plan, not the legacy slug.
 */
export const getRecommendedCoursePlanHref = (slug: string): string => {
	const normalized = normalizeCertificationSlug(slug);
	const planSlug =
		normalized === "certified-personal-trainer"
			? "certified-personal-trainer"
			: slug;
	return `/certifications/${planSlug}/recommended-course-plan`;
};

export const isCptCertificationSlug = (slug: string): boolean =>
	normalizeCertificationSlug(slug) === "certified-personal-trainer";
